import { orientationOf, type Orientation } from './orientation';

/**
 * Design canvases in design units: portrait as tall as the practice screen needs (see tokens.css)
 * and the landscape design.
 */
export const DESIGN_CANVAS: Record<Orientation, { width: number; height: number }> = {
  portrait: { width: 390, height: 780 },
  landscape: { width: 844, height: 420 },
};
/** Largest scale of the design, reached on tablets and desktops. */
export const MAX_SCALE = 1.45;

/**
 * One design unit in CSS pixels for a viewport; mirrors `--u` in src/styles/tokens.css for code
 * that draws outside CSS, such as PixiJS effects. The UI column is the viewport width, narrowed so
 * the whole canvas fits the height, and capped at MAX_SCALE.
 */
export function designUnit(viewportWidth: number, viewportHeight: number): number {
  const canvas = DESIGN_CANVAS[orientationOf(viewportWidth, viewportHeight)];
  const column = Math.min(
    viewportWidth,
    (viewportHeight * canvas.width) / canvas.height,
    canvas.width * MAX_SCALE,
  );
  return column / canvas.width;
}
